import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import Select from 'react-select';
import jwt_decode from "jwt-decode";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class ProductTypeFilter extends Component {
    state = {
        productTypeLists: [{value: '', label: 'All'}],
        productTypeValue: {value: '', label: 'All'},
        isProductLoading: true,
        isDisabled:false
    };
    componentDidMount(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        if(decoded.userGroupName==='Meta Users')
        {
            this.setState({
                isDisabled:true,
                productTypeValue: {value: 'True EMI', label: 'G.E.N.I.E'},
            })
        }
        this.setState({
            userGroupName:decoded.userGroupName
        })
        this.get_product_master();

    }

    resetProductTypeFilter(){

     if(this.state.userGroupName==='Meta Users')
        {
            this.setState({
                productTypeValue: {value: 'True EMI', label: 'G.E.N.I.E'},
            })
        } else {
            this.setState({
                productTypeValue: {value: '', label: 'All'},
            })
        }
    }
    get_product_master(){
        axios.get(config.get('API_URL')+'/filters/get-product-master/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_type: this.props.userType,
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((product, index) => {
                    this.state.productTypeLists.push({value: product.product_code, label: product.product_display_name})
                });
            }
            this.setState({
                loading:false,
                isProductLoading: false
            })
        });

    }
    changeProductType(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
        this.props.onSelectProduct(optionSelected);
        this.setState({

            productTypeValue:optionSelected,
        });
    }

    render() {

        return (
            <Select name="product_type"
            isDisabled={this.state.isDisabled}
            value={this.state.productTypeValue}
            styles={reactSelectStyles} className="report-listbox"
            isClearable={false}
            onChange={this.changeProductType.bind(this)}
            options={this.state.productTypeLists}
            isLoading={this.state.isProductLoading}
            placeholder="[Product Type]"
         />
        );

    }
}
export default ProductTypeFilter;